import type { Embarcacao } from "@/modules/embarcacoes";
import {
  EMBARCACOES_ACTIONS_KEY,
  EMBARCACOES_COLUMN_WIDTHS_REM,
  EMBARCACOES_COLUMNS,
  EMBARCACOES_MOBILE_COLUMN_WIDTHS_REM,
} from "./embarcacoes.constants";
import type { EmbarcacoesColumnKey } from "./embarcacoes.constants";

/** Linha da tabela: a embarcação com o que a View mostra, já pronto. */
export interface EmbarcacaoLinha {
  readonly id: string;
  readonly embarcacao: Embarcacao;
  readonly situacao: string;
  readonly detailLabel: string;
  readonly detailTestId: string;
}

/** Texto da Situação (Figma 7945:222882 a desenha como texto): Ativo e Inativo padronizados, outro valor como veio. */
export function describeSituacao(situacao: string | null | undefined): string {
  const text = situacao?.trim() ?? "";
  const normalized = text.toLowerCase();
  return normalized === "ativo" ? "Ativo" : normalized === "inativo" ? "Inativo" : text;
}

export function buildEmbarcacaoLinha(embarcacao: Embarcacao): EmbarcacaoLinha {
  return {
    id: embarcacao.id,
    embarcacao,
    situacao: describeSituacao(embarcacao.situacao),
    detailLabel: `Detalhar embarcação ${embarcacao.nome || embarcacao.acronimo}`,
    detailTestId: `embarcacoes-detail-${embarcacao.id}`,
  };
}

export interface EmbarcacoesColuna {
  readonly key: EmbarcacoesColumnKey;
  readonly header: string;
  /** Campo de ordenação do contrato; a lupa não ordena. */
  readonly sortable: boolean;
  readonly width: string;
}

/** Colunas da tabela com a largura do Figma (desktop ou mobile) e a lupa no fim. */
export function buildEmbarcacoesColunas(isMobile: boolean): EmbarcacoesColuna[] {
  const widthOf = (key: EmbarcacoesColumnKey) =>
    `${(isMobile ? EMBARCACOES_MOBILE_COLUMN_WIDTHS_REM[key] : undefined) ?? EMBARCACOES_COLUMN_WIDTHS_REM[key]}rem`;

  return [
    ...EMBARCACOES_COLUMNS.map(({ key, header }) => ({
      key,
      header,
      sortable: true,
      width: widthOf(key),
    })),
    { key: EMBARCACOES_ACTIONS_KEY, header: "", sortable: false, width: widthOf("acoes") },
  ];
}

/** Soma das larguras: abaixo disso a tabela rola na horizontal em vez de espremer as colunas. */
export function sumColumnWidthsRem(colunas: readonly EmbarcacoesColuna[]): number {
  return colunas.reduce((sum, coluna) => sum + Number.parseFloat(coluna.width), 0);
}
